/* eslint-disable camelcase */
import { useLocation } from 'react-router-dom';
import { useGTMDataLayer } from '../../../hooks/GTM/useGTMDataLayer';
import useCloseMenu from '../../../hooks/useCloseMenu';
import useEspial from '../../../hooks/Espial/useEspial';
import { useTrackCTA } from '../CtaClick/TrackCtaClick';

export const useHandleBecomeMemberClick = () => {
  const dataLayer = useGTMDataLayer();
  const trackCTA = useTrackCTA();
  const location = useLocation();
  const closeMenu = useCloseMenu();
  const { trackMenuClick } = useEspial();

  return () => {
    trackMenuClick([
      { menu_section_name: 'Topbar' },
      { menu_item_name: 'Bli medlem' },
      { menu_item_url: '/medlemskap' },
    ]);

    trackCTA({
      cta_position: 'topbar',
      text: 'Bli medlem',
      url: '/medlemskap',
      menuPage: location.pathname,
      menuItemName: 'Bli medlem',
      menuItemUrl: '/medlemskap',
    });

    dataLayer?.push({
      event: 'menu_click',
      menuPage: location.pathname,
      menuItemName: 'Bli medlem',
      menuItemUrl: '/medlemskap',
      menuSectionName: 'Topbar',
    });
    closeMenu();
  };
};

export const useHandleBookAppointmentClick = () => {
  const dataLayer = useGTMDataLayer();
  const trackCTA = useTrackCTA();
  const location = useLocation();
  const closeMenu = useCloseMenu();
  const { trackMenuClick } = useEspial();

  return () => {
    trackMenuClick([
      { menu_section_name: 'Topbar' },
      { menu_item_name: 'Bestill time' },
      { menu_item_url: '/bilverksted-og-tester' },
    ]);

    trackCTA({
      cta_position: 'topbar',
      text: 'Bestill time',
      url: '/bilverksted-og-tester',
      menuPage: location.pathname,
      menuItemName: 'Bestill time',
      menuItemUrl: '/bilverksted-og-tester',
    });

    dataLayer?.push({
      event: 'menu_click',
      menuPage: location.pathname,
      menuItemName: 'Bestill time',
      menuItemUrl: '/bilverksted-og-tester',
      menuSectionName: 'Topbar',
    });
    closeMenu();
  };
};

export const useHandleNavigationClick = ({
  event,
  menuSectionName,
  menuItemUrl,
  menuItemName,
  menuPage,
  onClickAction,
  mobileMenuGroup,
}: {
  event?: string;
  menuSectionName?: string;
  menuItemUrl?: string;
  menuItemName?: string;
  menuPage?: string;
  mobileMenuGroup?: string;
  onClickAction?: () => void;
}) => {
  const dataLayer = useGTMDataLayer();
  const closeMenu = useCloseMenu();
  const { trackMenuClick } = useEspial();

  return () => {
    trackMenuClick([
      { menu_section_name: menuSectionName },
      { menu_item_name: menuItemName },
      { menu_item_url: menuItemUrl },
      { mobile_menu_group: mobileMenuGroup },
    ]);

    const data = {
      event,
      menuSectionName,
      menuItemUrl,
      menuItemName,
      menuPage,
      mobileMenuGroup,
    };
    dataLayer?.push(data);
    closeMenu();

    if (onClickAction) {
      onClickAction();
    }
  };
};
